import { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { Loader2, ArrowLeft } from "lucide-react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AdminLogin() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const { user, ready, login } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (ready && user) navigate("/admin", { replace: true });
  }, [ready, user, navigate]);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      login(data.token, data.user);
      toast.success("Welcome back, Admin.");
      navigate("/admin", { replace: true });
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0A1128] text-white grain flex items-center justify-center px-5">
      <div className="relative z-10 w-full max-w-md">
        <Link to="/" className="inline-flex items-center gap-2 text-white/50 hover:text-white text-sm uppercase tracking-[0.15em] mb-8 transition-colors duration-200">
          <ArrowLeft className="w-4 h-4" /> Back to site
        </Link>
        <div className="flex items-center gap-3 mb-8">
          <img src="/logo-emblem.png" alt="logo" className="h-14 w-auto" />
          <span className="font-display text-2xl">PATRIOT POWER <span className="text-[#D90429]">USA</span></span>
        </div>
        <h1 className="font-display text-4xl uppercase leading-none">Command Center</h1>
        <p className="text-white/50 mt-2 mb-8">Authorized personnel only.</p>

        <form onSubmit={submit} data-testid="admin-login-form" className="bg-white text-[#0A1128] p-8">
          <label className="block text-xs uppercase tracking-[0.15em] font-semibold text-slate-500 mb-2">Email</label>
          <input
            data-testid="login-email-input"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            className="w-full border border-slate-300 px-4 py-3 rounded-none focus:outline-none focus:border-[#D90429] transition-colors duration-200 mb-5"
          />
          <label className="block text-xs uppercase tracking-[0.15em] font-semibold text-slate-500 mb-2">Password</label>
          <input
            data-testid="login-password-input"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            className="w-full border border-slate-300 px-4 py-3 rounded-none focus:outline-none focus:border-[#D90429] transition-colors duration-200 mb-6"
          />
          <button
            type="submit"
            disabled={loading}
            data-testid="login-submit-button"
            className="w-full bg-[#D90429] text-white py-4 uppercase tracking-[0.2em] text-sm font-bold hover:bg-[#b0031f] transition-colors duration-200 active:scale-[0.99] disabled:opacity-60 flex items-center justify-center gap-2"
          >
            {loading ? <><Loader2 className="w-4 h-4 animate-spin" /> Authenticating…</> : "Log In"}
          </button>
        </form>
      </div>
    </div>
  );
}
